import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// Finance Quotations tab — GET /api/quotation/admin, the SAME endpoint the pharmacist
// Quotations screen reads (§5.5 directive). `Quotation.getAdmin` (pillup-api) was fixed
// to two-phase pagination as part of this work (§5.5 Change 4) — a pre-existing bug that
// over-counted rows/pages whenever a quotation had 2+ paymentItems. The row counts this
// hook returns are the CORRECTED ones, not the pharmacist screen's old (inflated) figure.
export default function useFinanceQuotations({ page = 1, size = 20, enabled = true } = {}) {
    const params = { page, size };

    return useQuery(
        ["finance-quotations", params],
        async () => {
            const result = await request({ url: "quotation/admin", method: "GET", params });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;

            const { count, rows } = body.data;
            return {
                quotations: rows || [],
                pagination: { page, size, total: Number(count) || 0 },
            };
        },
        { keepPreviousData: true, retry: false, enabled }
    );
}
